import UtmSetter from "../lib/utm-setter";
import {dynamicMask} from "./phone-mask";

export default class SomeStuff {
    constructor() {
        this.init()
    }

    init() {

        try {
            let utmSetter = new UtmSetter();
            utmSetter.init()
        } catch (e) {
            console.warn('UtmSetter initialization error')
        }

        document.querySelectorAll('input[type="tel"]').forEach(function (el) {
            el.addEventListener('input', function () {
                this.value = dynamicMask(this.value, '8 (D##) ###-##-##')
            })
        })

        document.querySelectorAll('.next-level-button').forEach(function (el) {
            el.addEventListener('click', function (e) {
                this.classList.toggle('active')
                this.nextElementSibling.classList.toggle('tring')
            })
        })
        document.addEventListener('click', (e) => {
            if(e.target && e.target.id !== 'next-level-button') {
                let nextLevelButton = document.getElementById('next-level-button');
                if (nextLevelButton && nextLevelButton.classList.contains('active')) {
                    nextLevelButton.classList.toggle('active');
                    nextLevelButton.nextElementSibling.classList.toggle('tring');
                }
            }
        })

        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        function checkIfBusinessChatIsSupported() {
            if(isIOS && !window.appleBusinessChat.isSupported()) {
                document.querySelector('.apple-business-chat').remove();
                document.querySelector('.ios-only').remove();
            }
        }
    }

}
